import {useParams, useRouteMatch} from 'react-router-dom';
import {HealthProfileForm} from '../../../../../../../components/health-profile-form/health-profile-form';
import {useAuth} from '../../../../../../../contexts/auth/context';
import {RolePermissionType} from '../../../../../../../backend/enums/role-permission-type';
import {Box, Card} from '@mui/material';
import GenericHeader from '../../../../../../../components/generic-header/generic-header';
import {useOffice} from '../../../../../../../contexts/office/context';
import {translations} from '../../../../../../../i18n/translations';
import {ScreenPaths} from '../../../../../../../enums';
import {useTranslation} from 'react-i18next';

export default function SeniorHealthProfessionalCaregiverOfficeScreen() {
  // Get params
  let {id, entityId}: {id?: string; entityId?: string} = useParams();
  const officeContext = useOffice();
  let {url} = useRouteMatch();
  const {t} = useTranslation();
  const {hasWritePermission} = useAuth();
  const canWriteSeniorHealth = hasWritePermission(RolePermissionType.Seniors_PersonalData_Health);
  const seniorName =
    officeContext.state.userForm?.user.displayName || officeContext.state.userForm?.user.name;

  return (
    <Box className="senior-health-wrapper">
      <GenericHeader
        titleCrumbs={[
          {
            label: t(translations.screen_paths.professional_caregiver_seniors),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
          },
          {
            label: seniorName,
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
          },
          {
            label: t(translations.screen_paths.senior_personal_data),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}`,
          },
          {
            label: t(translations.screen_paths.senior_health),
            link: url,
          },
        ]}
        isLoading={false}
        leftColumn={null}
      />
      <Card className="senior-health-card" elevation={0}>
        <HealthProfileForm userId={id || ''} canWrite={canWriteSeniorHealth} />
      </Card>
    </Box>
  );
}
